import styles from "./AppChevron.module.scss";

const ROTATION_DEGREES = {
  left: 0,
  right: 180,
  up: 90,
  down: -90,
};

const SVG_VIEWBOX_SIZE = 38;
const SVG_CENTER = SVG_VIEWBOX_SIZE / 2;
const PRIMARY_VIEWBOX = "12 12 14 14";
const DEFAULT_VIEWBOX = `0 0 ${SVG_VIEWBOX_SIZE} ${SVG_VIEWBOX_SIZE}`;

export function AppChevron(props: {
  className?: string;
  disabled?: boolean;
  disableHover?: boolean;
  size?: number;
  orientation?: "up" | "down" | "left" | "right";
  tone?: "default" | "primary";
}) {
  const {
    orientation = "left",
    size = 38,
    disableHover = false,
    disabled = false,
    tone = "default",
  } = props;

  return (
    <span
      className={`${styles.container} ${disabled ? styles.disabled : ""} ${disableHover ? styles.disableHover : ""} ${tone === "primary" ? styles.tonePrimary : ""}`}
      data-testid={`chevron-${orientation}`}
    >
      <svg
        className={styles.chevron}
        width={size}
        height={size}
        viewBox={tone === "primary" ? PRIMARY_VIEWBOX : DEFAULT_VIEWBOX}
        fill="fill"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          transform={`rotate(${ROTATION_DEGREES[orientation]} ${SVG_CENTER} ${SVG_CENTER})`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.4244 24.9313C22.7827 24.5909 22.7827 24.0392 22.4244 23.6988L17.427 18.9521L22.4244 14.2055C22.7827 13.8651 22.7827 13.3133 22.4244 12.973C22.0661 12.6327 21.4852 12.6327 21.1269 12.973L15.4806 18.3359C15.1223 18.6763 15.1223 19.2281 15.4806 19.5684L21.1269 24.9313C21.4852 25.2716 22.0661 25.2716 22.4244 24.9313Z"
            fill="fill"
          />
        </g>
      </svg>
    </span>
  );
}
